<template>
     <table class="opening-hours-table">
    
         <tr v-for="openingHour in openingHours" :key="openingHour.date">
             <td class="opening-hours-table__date">
                 {{openingHour.weekDay}} <small>(d. {{ openingHour.date }})</small>
             </td>
             <td class="opening-hours-table__time">
                 
                     <span v-if="openingHour.isClosed">Lukket</span>
                     <span v-else>{{openingHour.from}} - {{openingHour.to}}</span>
             </td>
         </tr>
 </table>
</template>
<script>
export default {
    name: "openingHours",
    props: ['openingHours']
};
</script>
